import React, { useState, useEffect } from 'react';
import hamburgerLogo from '../../../images/icons/hum.svg';
import customerService from '../../../images/icons/customer-service.svg';
import notification from '../../../images/icons/Group.svg';
import profileAv from '../../../images/icons/profileAv2x.png';
import chevron from '../../../images/icons/chevron.svg';
import { isLoggedIn, getUserNumber } from '../../utils/cookie-utils';
import ProfileModal from '../ProfileModal/ProfileModal';
import headerCons from '../../../images/consumer/headerCons.svg';
import { navigate } from 'gatsby';

export default function Header({ bgWhite }) {
  const isLogged = isLoggedIn();
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem('userData')) || ''
  );
  const [show, setShow] = useState(false);

  const openNav = () => {
    const x = document.getElementById('sideBar');
    x.style.display = 'block';
    x.style.opacity = 1;
    x.style.width = '100%';
  };

  return (
    <>
      <div
        className={
          (bgWhite ? 'bg-white' : 'bg-transparent') +
          '  md:flex md:flex-row justify-between  w-full h-20 hidden '
        }
        style={{ ...(bgWhite ? { boxShadow: '0px 3px 12px #DCE9F8' } : {}) }}
      >
        {/* mobile icons */}
        <div>
          <div className=" block md:hidden h-12 w-12 ml-3 mt-4">
            <img
              className="block object-cover cursor-pointer"
              onClick={() => openNav()}
              src={hamburgerLogo}
              alt="menu"
            />
          </div>
        </div>
        <div className="inline-flex md:hidden items-center justify-center">
          <div className=" block md:hidden h-12 w-12 ml-3 mt-4">
            <img
              className="block object-cover"
              src={customerService}
              alt="menu"
            />
          </div>
          <div className=" block md:hidden h-12 w-12 ml-3 mt-4">
            <img className="block object-cover" src={notification} alt="menu" />
          </div>
        </div>

        {/* // consumer logo */}
        {bgWhite && (
          <div
            className="mr-auto ml-25 my-4"
            onClick={() => {
              if (isLogged) navigate('/user/home');
            }}
          >
            <img
              className="block object-cover h-12"
              src={headerCons}
              alt="welcome"
            />
          </div>
        )}
        <div>
          <div className=" block md:hidden h-12 w-12 ml-3 mt-4">
            <img className="block object-cover" src={notification} alt="menu" />
          </div>
        </div>

        {isLogged ? (
          <div className="dropdown hidden md:inline-flex flex-shrink-0 items-center justify-around md:justify-around w-auto profileImg mr-3">
            <div className="">
              <img
                className="w-10 h-10 rounded-full"
                src={profileAv}
                alt="logo"
              />
            </div>
            <div className="hidden md:block">
              <p className="text-lg ml-3">
                {userDetails
                  ? `${userDetails?.name?.firstName?.substring(0, 20) || 'NA'}`
                  : `${getUserNumber()?.substring(0, 20) || 'NA'}`}
              </p>
            </div>
            <div className="ml-3 flex flex-col cursor-pointer">
              <div
                onClick={(e) => {
                  setShow(!show);
                }}
              >
                <img
                  className={show ? 'block transform rotate-180' : ''}
                  src={chevron}
                  alt="v"
                />
                <ProfileModal show={show} setShow={setShow} />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}
